module.exports = __webpack_public_path__ + "static/media/info.b13f1d1c.svg";